module.exports = __webpack_public_path__ + "media/images/emblems/Armoiries_bercher-818866180d2656f85f135206b5475169.svg";